import editorRule from '@/components/atoms/editorRule'
import { PortableText } from 'next-sanity'

const Description = ({ description }) => {
  const base =
    'content relative w-full text-bodyMobile md:text-bodyDesktop text-olive font-chivoMono'

  return (
    <div className={base}>
      <PortableText value={description} components={editorRule()} />
    </div>
  )
}

export default Description
